import axios from "axios";
import dayjs from "dayjs"
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"
import Loadingwrapper from "../../component/LoadingWrapper";
import Popup from "../../component/Popup";
import HashtagPageFilters from "../HashtagPage/PageFilters";
import CaptionImages from "./CaptionImages";
import ImageFullData from "./ImageFullData";

const limit = 200;
const LOWESTDATEALLOWED = '01-07-2025'

const defaultDate = dayjs(LOWESTDATEALLOWED, 'DD-MM-YYYY').toDate()

const CaptionPage = () => {
  const [searchParams, setSearchParams] = useSearchParams({ from: LOWESTDATEALLOWED, to: "", geography: "All", page: "1" })
  const [images, setImages] = useState([])
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)
  const [srStartCount, setSrStartCount] = useState(0)
  const [selectedImage, setSelectedImage] = useState(null)

  const selectImage = (e) => {
    const element = e.target
    const buttonElement = element ? element.closest("button") : null
    if (buttonElement) {
      const selectedMediaId = buttonElement.id
      const image = images.filter(img => img.mediaId == selectedMediaId)[0]
      setSelectedImage(image || null)
    }
  }

  const getHashtags = async () => {
    setLoading(true)
    const response = await axios.get(`/api/hashtag/captions/images?from=${searchParams.get('from')}&to=${searchParams.get('to')}&geography=${searchParams.get('geography')}&page=${searchParams.get('page') || '1'}`)
    setTotal(response.data.count)
    setImages(response.data.images)
    setLoading(false)
  }

  const changePage = (newPage) => {
    setSearchParams(prev => {
      prev.set('page', newPage)
      return prev;
    })
  }

  useEffect(() => {
    getHashtags()
  }, [searchParams.get('from'), searchParams.get('to'), searchParams.get('geography'), searchParams.get('page')])

  useEffect(() => {
    const page = parseInt(searchParams.get('page') || '1')
    setSrStartCount(limit * (page - 1))
  }, [searchParams.get('page')])

  return <div>
    <h2 className="text-center text-lg my-2 font-semibold">Caption Leaderboard</h2>
    <HashtagPageFilters searchParams={searchParams} setSearchParams={setSearchParams} LOWESTDATEALLOWED={LOWESTDATEALLOWED} defaultDate={defaultDate} total={total} changePage={changePage} limit={limit} />
    <div className="flex m-2">

    </div>
    <Loadingwrapper loading={loading} className={"h-[80vh]"}>
      <CaptionImages images={images} srStartCount={srStartCount} selectImage={selectImage} />
    </Loadingwrapper>

    {
      selectedImage ? <Popup isPopUp={selectedImage} setIsPopUp={() => {
        setSelectedImage(null)
      }}>
        <ImageFullData image={selectedImage} />
      </Popup>
        : null
    }


  </div>
}


export default CaptionPage
